export default "__VITE_ASSET__DPYyeZkp__"